export default __webpack_public_path__ + "static/media/Commercials_and_Packshots.b3a3e07a.jpg";